import React from "react";
import { Link } from "react-router-dom";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import VideoModal from "../ModalVideo/VideoModal";
import blogs, { Blog } from "../../api/blogs";

interface BlogListProps {
  pageStyle?: string;
  blLeft?: boolean;
}

const ClickHandler = (): void => {
  window.scrollTo(10, 0);
};

const BlogList: React.FC<BlogListProps> = ({ pageStyle, blLeft }) => {
  return (
    <section
      className={`wpo-blog-pg-section ${pageStyle || ""} section-padding`}
    >
      <div className="container-fluid">
        <div className="wpo-blog-wraper">
          <div className="wpo-blog-content">
            {/* 📰 Blog List */}
            {blogs.slice(0, 4).map((blog: Blog, index: number) => (
              <div className={`post ${blog.blClass}`} key={blog.id || index}>
                <div className="entry-media video-holder">
                  <img src={blog.blogSingleImg} alt={blog.title} />
                  {blog.videoBtn && <VideoModal />}
                </div>

                <div className="entry-details">
                  <div className="entry-meta">
                    <ul>
                      <li>
                        <i className="fi flaticon-user"></i> By{" "}
                        <Link
                          onClick={ClickHandler}
                          to={`/blog-single/${blog.slug}`}
                        >
                          {blog.author}
                        </Link>
                      </li>
                      <li>
                        <i className="fi flaticon-comment-white-oval-bubble"></i>{" "}
                        Comments {blog.comment}
                      </li>
                      <li>
                        <i className="fi flaticon-calendar"></i>{" "}
                        {blog.create_at}
                      </li>
                    </ul>
                  </div>

                  <h3>
                    <Link
                      onClick={ClickHandler}
                      to={`/blog-single/${blog.slug}`}
                    >
                      {blog.title}
                    </Link>
                  </h3>

                  <p>
                    Law is a great career path if you want to build a broad
                    skill set that includes everything from critical thinking
                    and strategic planning to communications. If you love rising
                    to a challenge.
                  </p>

                  <Link
                    onClick={ClickHandler}
                    to={`/blog-single/${blog.slug}`}
                    className="read-more"
                  >
                    READ MORE...
                  </Link>
                </div>
              </div>
            ))}

            {/* 🔢 Pagination */}
            <div className="pagination-wrapper pagination-wrapper-left">
              <ul className="pg-pagination">
                <li>
                  <Link to="/blog-left-sidebar" aria-label="Previous">
                    <i className="fi ti-angle-left"></i>
                  </Link>
                </li>
                <li className="active">
                  <Link to="/blog-left-sidebar">1</Link>
                </li>
                <li>
                  <Link to="/blog-left-sidebar">2</Link>
                </li>
                <li>
                  <Link to="/blog-left-sidebar">3</Link>
                </li>
                <li>
                  <Link to="/blog-left-sidebar" aria-label="Next">
                    <i className="fi ti-angle-right"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* 📚 Sidebar */}
          <BlogSidebar blLeft={blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogList;
